import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./geofence-create.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuInput from "../../../../elements/velavu-input";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import VelavuButton from "../../../../elements/velavu-button";

export interface GeofenceCreateProps {
	name: string;
	onChangeName: (name: string) => void;

	onClose?: () => void;
	onSubmit?: () => void;
	disabled?: boolean;
	isEditing?: boolean;
	isLoading?: boolean;
}

export default function GeofenceCreate(props: GeofenceCreateProps) {
	const { t } = useTranslation();
	const nameOK = useMemo(() => props.name.trim().length > 0, [props.name]);

	return (
		<PinnedList>
			<PinnedListHeader
				label={
					props.isEditing
						? t("dashboard.geofence_create.header_edit")
						: t("dashboard.geofence_create.header_new")
				}
				onClose={props.onClose}
			/>

			<div className={styles.container}>
				<VelavuInput
					value={props.name}
					onChange={props.onChangeName}
					fullWidth
					titleText={t("dashboard.geofence_create.name_label")}
				/>

				<VelavuNotice type="info">
					{t("dashboard.geofence_create.instructions")}
				</VelavuNotice>

				<VelavuButton
					label={t("dashboard.geofence_create.finish")}
					fullWidth
					disabled={props.disabled || !nameOK}
					loadingIndicator={props.isLoading}
					onClick={props.onSubmit}
				/>
			</div>
		</PinnedList>
	);
}
